import React from 'react'
import ContestPage from 'ets/components/lib/contest/ContestPage'
import ContestSource from 'ets/components/lib/contest/ContestSource.enum'

const Page: React.FC = props => <ContestPage source={ContestSource.AWS_VAR} {...props} />

export default Page
